import styled from "styled-components";
import { Table, TableContainer } from "@material-ui/core";

export const StyledTable = styled(Table)`
    min-width: 100%;
`;

export const StyledTableContainer = styled(TableContainer)`
    max-height: 650px;
`;
